import { atom, useAtom } from 'jotai'
import { useCallback } from 'react'

export type ValidFocusTarget =
	| { target: 'none' }
	| { target: 'feed-ad(backdrop)' }
	| { target: 'feed-ad(contentTitle)' }
	| { target: 'feed-ad(contentSubtitle)' }
	| { target: 'feed-ad(contentLocation)' }
	| { target: 'feed-ad(contentCta)' }
	| { target: 'story-ad(backdrop)' }
	| { target: 'story-ad(contentTitle)' }
	| { target: 'story-ad(contentSubtitle)' }

export const editorFocusLockAtom = atom<boolean>(false)
export const editorFocusTargetAtom = atom<ValidFocusTarget>({
	target: 'none',
})

export const showCanvasToolbarAtom = atom(false)

export type EditorUserIsViewing = 'feed' | 'story' | 'landing' | 'form' | 'thank-you' | 'export' | 'unknown'
export const editorUserIsViewingAtom = atom<EditorUserIsViewing>('feed')

// useSimulatorFocus is usually better; this is a low level hook.
export function useEditorFocusState() {
	const [focusTarget, setFocusTarget] = useAtom(editorFocusTargetAtom)

	const defocus = useCallback(() => {
		setFocusTarget({ target: 'none' })
	}, [setFocusTarget])

	const toggleFocus = useCallback((target: ValidFocusTarget) => {
		if (focusTarget.target === target.target) {
			setFocusTarget({ target: 'none' })
		} else {
			setFocusTarget(target)
		}
	}, [focusTarget, setFocusTarget])

	return {
		focusTarget,
		setFocusTarget,
		defocus,
		toggleFocus,
	}
}
